/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UserDocumentsControllerDeleteDocument$Params {
  userId: string;
  documentId: string;
}

export function userDocumentsControllerDeleteDocument(http: HttpClient, rootUrl: string, params: UserDocumentsControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, userDocumentsControllerDeleteDocument.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

userDocumentsControllerDeleteDocument.PATH = '/user-documents/{userId}/{documentId}';
